import axios from "axios"

const instance = axios.create({
  baseURL: "https://amazonbackend3.onrender.com/",
});
export default instance
